module.exports = __webpack_public_path__ + "img/BannerLife_Logo_Black_325x143.a69574e2.svg";